import { Button, Col, Row } from "antd";
import styles from "./MemberDetails.module.css";
import { GoPencil } from "react-icons/go";
import MemberActivityTable from "./MemberActivityTable";
import MemberServices from "../../../../services/MemberServices";
import { useState } from "react";
import useNotification from "../../../../hooks/useNotification";
import InfoEditModal from "./InfoEditModal";

const MemberDetails = ({ data = {}, fetchUserOverviewData }) => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  
  const handleEdit = () => {
    setShowModal(true);
  };

  const revokeAccess = async () => {
    if (data?._id) {
      try {
        setLoading(true);
        let res = await MemberServices.revokeAccess(data?._id);
        if (res) {
          if (res.statusCode === 1) {
            fetchUserOverviewData(data?._id);
            showNotification(
              `Member access ${!data.isActive ? "Re-initated" : "Revoked"}`
            );
          } else {
            handleError(`${res.statusDesc}`);
          }
        } else {
          handleError(`Error: ${res.statusDesc}`);
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        handleError(`Error: ${error.message}`);
      }
    }
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleSubmit = () => {
    fetchUserOverviewData(data?._id);
  };
  return (
    <div className={styles.content_wrap}>
      <Row gutter={[14, 14]}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={6}
          xl={6}
          id="graph_col"
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap}>
            <div>
              <div className={styles.header_wrap}>
                {data.firstName} {data.lastName}
              </div>
              <div className={styles.box_wrap_2}>
                <div className={styles.first_row}>
                  <div>
                    <div className={styles.label}>Sector</div>
                    <div className={styles.info}>{data.department}</div>
                  </div>
                  <div>
                    <button className={styles.edit_btn} onClick={handleEdit}>
                      <GoPencil />
                      Edit
                    </button>
                  </div>
                </div>
                <div>
                  <div className={styles.label}>Email</div>
                  <div className={styles.info}>{data.emailAddress}</div>
                </div>
                <div>
                  <div className={styles.label}>Role</div>
                  <div className={styles.info}>
                    <div
                      className={`
                        ${styles.badge} ${styles.blue_badge}
                        `}
                    >
                      {data.role?.toUpperCase()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Button
              className={
                !data.isActive ? styles.reinitiate_btn : styles.revoke_btn
              }
              loading={loading}
              onClick={revokeAccess}
            >
              {!data.isActive ? "Re-initate Access" : "Revoke Access"}
            </Button>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={18} xl={18}>
          <div>
            <MemberActivityTable />
          </div>
        </Col>
      </Row>
      <InfoEditModal
        data={data}
        isOpen={showModal}
        onCancel={setShowModal}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default MemberDetails;
